module.exports = __webpack_public_path__ + "static/img/contact-img.29e5141.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/contact-img.png
// module id = mp6x
// module chunks = 1